/**
 * Black placeholder + white loading bar until images load.
 */
(function () {
  if (document.documentElement.classList.contains('animations-fast-mode') || window.themeAnimationsFastMode === true) return;

  const SELECTOR =
    '#MainContent img, .shopify-section-group-header-group img, .shopify-section-group-footer-group img, .product-media-modal img';

  function shouldSkip(img) {
    if (!img || img.nodeName !== 'IMG') return true;
    if (img.dataset.imageLoading) return true;
    if (img.dataset.imageLoadingOff === 'true') return true;
    if (img.closest('.no-image-loading')) return true;
    if (img.closest('.image-loading')) return true;
    const src = img.getAttribute('src');
    if (!src || src.startsWith('data:')) return true;
    if (img.classList.contains('visually-hidden')) return true;
    if (img.loading === 'eager') return true;
    if ((img.getAttribute('fetchpriority') || '').toLowerCase() === 'high') return true;
    if (img.closest('.product__media-item.is-active, .banner__media, .premium-hero-slideshow__slide.is-active')) return true;
    const w = parseInt(img.getAttribute('width') || img.width, 10);
    const h = parseInt(img.getAttribute('height') || img.height, 10);
    if (w > 0 && w < 20 && h > 0 && h < 20) return true;
    return false;
  }

  function finish(wrap) {
    wrap.classList.add('is-loaded');
  }

  function enhance(img) {
    if (shouldSkip(img)) return;
    if (img.complete && img.naturalWidth > 0) return;

    img.dataset.imageLoading = 'pending';

    const wrap = document.createElement('span');
    wrap.className = 'image-loading';
    wrap.setAttribute('role', 'presentation');
    const track = document.createElement('span');
    track.className = 'image-loading__track';
    const fill = document.createElement('span');
    fill.className = 'image-loading__fill';
    track.appendChild(fill);
    wrap.appendChild(track);

    const parent = img.parentNode;
    if (!parent) {
      delete img.dataset.imageLoading;
      return;
    }

    parent.insertBefore(wrap, img);
    wrap.appendChild(img);

    let settled = false;
    const done = () => {
      if (settled) return;
      settled = true;
      finish(wrap);
    };

    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });

    if (img.complete && img.naturalWidth > 0) {
      done();
    } else if (img.decode && typeof img.decode === 'function') {
      img.decode().then(done).catch(done);
    }

    img.dataset.imageLoading = 'on';
  }

  function scan(root) {
    const el = root && root.nodeType === 1 ? root : document;
    let imgs;
    if (el.nodeName === 'IMG') {
      imgs = [el];
    } else if (el.querySelectorAll) {
      imgs = el.querySelectorAll(SELECTOR);
    } else {
      imgs = [];
    }
    imgs.forEach((img) => {
      try {
        enhance(img);
      } catch (_) {
        /* ignore */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document));
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
